import { Form, Select, Switch } from "antd";

const SwitchItem = ({
  options,
  onChange,
  title,
  title2,
  name1,
  name2,
  defaultValue,
}: any) => {
  return (
    <div className="flex items-center justify-between w-full -mb-[25px] h-[65px]">
      <div className="flex items-center">
        {title}
        {name1 && (
          <div className="flex items-center gap-2 w-fit">
            <Form.Item
              name={name1}
              required={false}
              rootClassName="flex items-center gap-2"
              className="flex items-center w-full mx-2 miw-w-[120px] !mb-[-0px]"
            >
              <Select defaultValue={defaultValue} options={options} />
            </Form.Item>
          </div>
        )}
        {title2 && (
          <div className="whitespace-nowrap text-center">{title2}</div>
        )}
      </div>

      <Form.Item name={name2}>
        <Switch />
      </Form.Item>
    </div>
  );
};

export default SwitchItem;
